<template>
  <el-dialog
    @closed="closed"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="550px"
    title="新建文件夹">
    <el-form
      :model="params"
      :rules="rules"
      ref="form"
      class="t-form"
      label-width="102px"
      label-position="left"
      size="medium"
	  @submit.native.prevent
      hide-required-asterisk>
      <el-form-item label="默认排序">
        <el-input
          v-model="caseNumber"
          class="input-width"
          readonly />
      </el-form-item>
      <el-form-item label="委托人" prop="human">
        <el-input
          v-model="params.human"
          class="input-width"
          placeholder="请输入委托人姓名"/>
      </el-form-item>
      <el-form-item label="项目名称" prop="name">
        <el-input
          v-model="params.name"
          class="input-width"
          placeholder="请输入项目名称"/>
      </el-form-item>
    </el-form>
    <div class="flex jc_e ai_c pt20">
      <t-btn
      	w="78px"
      	h="36px"
      	fs="14px"
      	type="info"
      	@click="visible = false" 
      	class="bold">取消</t-btn>
      <t-btn
        @click="commit"
        w="78px"
        h="36px"
        fs="14px"
        class="bold ml10">确认</t-btn>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      parentId: null,
      caseNumber: '',
      params: {
        name: '',
        human: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入项目名称' },
        ],
        human: [
          { required: true, message: '请输入委托人姓名' },
        ],
      }
    }
  },
  methods: {
    // 确认
    commit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('commit', { ...this.params, parentId: this.parentId })
          this.visible = false;
        }
      })
    },
    // 显示
    show(parentId = null) {
      this.visible = true
      this.parentId = parentId
      this.$api.cases.getCaseNumber({ parentId }).then(res => {
        this.caseNumber = res.tag + '-' + res.number
      })
    },
    // 关闭重置
    closed() {
      this.parentId = null
      this.caseNumber = ''
      this.$refs.form.resetFields()
    }
  }
}
</script>
